// full list of top menu items can be found in
// https://github.concur.com/travel/library-concur-web/blob/master/Concur.Web/MVC/MainMenu.cs#L23
// Skipped items:
// TravelManagerAuthorization - gov only
// TravelManagerVoucher - gov only
// TravelManagerApproval - gov only
// Processing - not found in menu.cshtml
// SupplierPortal - moved inside Invoice
// SupplierPortalAdmin - moved inside Company Admin
// PurchaseRequest - moved inside Request
// Setup - moved inside Administration
// Support - moved inside Help Portal
// AskAQuestion, BreezeSubscribe - removed
// LocateAndAlert, RiskMessaging - sunset in 2019
// Audit, replaced with Verify in expense submenu
// TestDrive - mobile only
export const sideNavIconMap = {
    // fallback home id
    home: 'home',
    // Home from menu.cshtml
    Dashboard: 'home',
    Request: 'request',
    Travel: 'luggage',
    Expense: 'credit-third-party',
    Approvals: 'employee-approvals',
    // Reporting
    Reports: 'expense-report',
    // App Center
    Connect: 'crm-sales',
    Administration: 'settings',
    // Links
    Favorites: 'combined-expense',
    // Expense.IsCentralReconUser
    CR: 'compare',
    Invoice: 'document',
    TripLink: 'globe',
    // overflow menu item
    overflow: 'kebab',
    // Pre-Spend Planner
    PreSpendPlanner: 'calculate',
    // Phase 2: Admin items promoted to top-level sidebar (SMNUI-20048)
    // Ids set explicitly via AddSubMenuItem or nameToIconId map in Menu.cshtml
    AdministrationHome: 'settings',
    ControlCenter: 'filter-analytics',
    AdminCompany: 'building',
    AdminExpense: 'expense-config',
    AdminInvoice: 'invoice-admin',
    AdminRequest: 'request-admin',
    AdminTravel: 'flight',
    AdminTools: 'wrench',
    AdminAISettings: 'document',
    // Below are menu items exclusively for supportability app (https://github.concur.com/t2/supportability-ui)
    // General Tools menu item
    wrench: 'wrench',
    // GDS menu item
    inspection: 'inspection',
    // Hotel menu item
    hotel: 'hotel',
};

export const getSideNavIcon = (id) => sideNavIconMap[id] || 'document';
